import React, { useState, useEffect, useRef } from "react";
import "./ToolMods.css";
import { getIcon } from "../../../utils/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleSnapMode,
  toggleObjectSnap,
  toggleOrthoMode,
  toggleGridMode,
  toggleSnapType,
  setAllSnapTypes,
} from "../../../redux/modsSlice";

const SNAP_TYPES = [
  { key: 'endpoint', label: 'Endpoint', icon: '□' },
  { key: 'midpoint', label: 'Midpoint', icon: '△' },
  { key: 'center', label: 'Center', icon: '○' },
  { key: 'vertex', label: 'Vertex', icon: '□' },
  { key: 'quadrant', label: 'Quadrant', icon: '◇' },
  { key: 'intersection', label: 'Intersection', icon: '✕' },
  { key: 'perpendicular', label: 'Perpendicular', icon: '⊥' },
  { key: 'tangent', label: 'Tangent', icon: '○─' },
  { key: 'nearest', label: 'Nearest', icon: '⏳' },
  { key: 'node', label: 'Node', icon: '⊕' },
  { key: 'extension', label: 'Extension', icon: '+' },
];

const ToolMods = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [snapDropdownOpen, setSnapDropdownOpen] = useState(false);
  const [snapDropdownPos, setSnapDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const snapDropdownRef = useRef(null);
  const snapTriggerRef = useRef(null);
  const buttonSize = 30;

  const snapMode = useSelector((state) => state.mods.snapMode);
  const objectSnap = useSelector((state) => state.mods.objectSnap);
  const orthoMode = useSelector((state) => state.mods.orthoMode);
  const gridMode = useSelector((state) => state.mods.gridMode);
  const enabledSnapTypes = useSelector((state) => state.mods.enabledSnapTypes);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'F8') dispatch(toggleOrthoMode());
      if (e.key === 'F4') dispatch(toggleSnapMode());
      if (e.key === 'F7' || e.key === 'F9') dispatch(toggleGridMode());
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (snapDropdownRef.current && !snapDropdownRef.current.contains(e.target)) {
        setSnapDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`toolMods ${isOpen ? "open" : "closed"}`}>
      {isOpen && (
        <div className="toolMods-left">
          <div className="toolRow">
            <button
              className={`toolModsButton ${orthoMode ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title={`Ortho Mode ${orthoMode ? "ON" : "OFF"} (F8)`}
              onClick={() => dispatch(toggleOrthoMode())}
            >
              {getIcon("ortho", 22)}
            </button>

            <div className="snapButtonGroup" ref={snapDropdownRef}>
              <button
                className={`toolModsButton ${snapMode ? "active" : ""}`}
                style={{ width: buttonSize, height: buttonSize }}
                title={`Snap Mode ${snapMode ? "ON" : "OFF"} (F4)`}
                onClick={() => dispatch(toggleSnapMode())}
              >
                {getIcon("snap", 22)}
              </button>
              <button
                className="snapDropdownArrow"
                ref={snapTriggerRef}
                onClick={() => {
                  if (!snapDropdownOpen && snapTriggerRef.current) {
                    const rect = snapTriggerRef.current.getBoundingClientRect();
                    setSnapDropdownPos({ top: rect.bottom + 2, left: rect.left, width: rect.width });
                  }
                  setSnapDropdownOpen(prev => !prev);
                }}
              >
                ▼
              </button>

              {snapDropdownOpen && (
                <div className="snapDropdownMenu" style={{ top: snapDropdownPos.top, left: snapDropdownPos.left, minWidth: snapDropdownPos.width }}>
                  <div className="snapDropdownItem"
                    onClick={() => dispatch(setAllSnapTypes(true))}>
                    <span className="snapCheckbox">☑</span> Hepsini Ac
                  </div>
                  <div className="snapDropdownItem"
                    onClick={() => dispatch(setAllSnapTypes(false))}>
                    <span className="snapCheckbox">☐</span> Hepsini Kapat
                  </div>
                  <div className="snapDropdownSeparator" />
                  {SNAP_TYPES.map(st => (
                    <div key={st.key} className="snapDropdownItem"
                      onClick={() => dispatch(toggleSnapType(st.key))}>
                      <span className="snapCheckbox">
                        {enabledSnapTypes[st.key] ? '☑' : '☐'}
                      </span>
                      <span className="snapTypeIcon">{st.icon}</span>
                      {st.label}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              className={`toolModsButton ${gridMode ? "active" : ""}`}
              style={{ width: buttonSize, height: buttonSize }}
              title={`Grid Mode ${gridMode ? "ON" : "OFF"} (F7 / F9) — başlangıç noktasından 5 birim kademeli`}
              onClick={() => dispatch(toggleGridMode())}
            >
              {getIcon("grid", 22)}
            </button>
          </div>
        </div>
      )}

      <div className="toolMods-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          {isOpen ? "◀" : "Mods▶"}
        </button>
      </div>
    </div>
  );
};

export default ToolMods;
